export { default as VideoSlider } from './VideoSlider';
